module.exports = __webpack_public_path__ + "media/images/prizes__third-f7c3eac805429e257974a0b61fcc3de3.jpg";